import moment from "moment";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import { useQuery } from "@apollo/client/react";
import { GET_ESTADOS_DOCUMENTOS_SAP } from "../../../data/graphQL/queries/DocumentosSAP/getEstadosDocumentosSAP";
import { useEffect, useState } from "react";

const idEstadoEnviado = 1;
export const useGetFilters = () => {
    const [estados, setEstados] = useState([]);

    const { filters, handleChangeFilters } = usePersistFilters({
        idEstado: idEstadoEnviado,
        fechaDesde: moment().startOf('month').format('YYYY-MM-DD'),
        fechaHasta: moment().endOf('month').format('YYYY-MM-DD'),
        numeroDoc: "",
    }, `documentosSapFilters`);

    const { data: dataEstados } = useQuery(GET_ESTADOS_DOCUMENTOS_SAP);

    useEffect(() => {
        if (dataEstados?.estadosDocumentoSap) {
            const estadosFormateados = dataEstados.estadosDocumentoSap.map(e => ({
                id: e.idEstadoDocumentoSap,
                displayName: e.descripcion
            }));
            setEstados(estadosFormateados);
        }
    }, [dataEstados]);

    return {
        filters,
        handleChangeFilters,
        estados
    };
};